import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { postClientUrlWithToken } from '../../../Utils/restUtils';
import { changeShiftStatus, changeShiftStatusRole, deleteShift, deleteShiftRole } from '../../../CommonUrl';

const ShiftCard = ({ shift, onRefresh }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(prevState => !prevState);

  const authState = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const handleStatusToggle = async () => {
    const newStatus = shift?.status === 'active' ? 'inactive' : 'active';
    const payload = {
      shift_id: shift?.id,
      status: newStatus
    };
    try {
      const response = await postClientUrlWithToken(
        authState.apiUrl,
        authState.userRole === 1 ? changeShiftStatus : changeShiftStatusRole,
        payload
      );
      if (response.status === 200) {
        if (response.data.status) {
          toast.success(`Status updated to ${newStatus} successfully`);
          if (onRefresh) onRefresh();
        } else {
          toast.error(response.data?.message || "Failed to update status");
        }
      } else {
        toast.error("Failed to update status");
      }
    } catch (error) {
      toast.error("An error occurred while updating status");
    }
  };

  const handleDelete = () => {
    SweetAlert.fire({
      title: 'Confirm deletion?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then(async (result) => {
      if (result.value) {
        const payload = { shift_id: shift?.id };
        try {
          const response = await postClientUrlWithToken(
            authState.apiUrl,
            authState.userRole === 1 ? deleteShift : deleteShiftRole,
            payload
          );
          if (response.status === 200) {
            if (response.data.status) {
              SweetAlert.fire('Deleted!', 'Shift has been deleted.', 'success');
              if (onRefresh) onRefresh();
            } else {
              toast.error(response.data?.message || "Failed to delete shift");
            }
          } else {
            toast.error("Failed to delete shift");
          }
        } catch (error) {
          toast.error("An error occurred while deleting shift");
        }
      }
    });
  };

  const handleEdit = () => {
    navigate(`${process.env.PUBLIC_URL}/attendance/shifts/edit?id=${shift?.id}`);
  };

  return (
    <div
      className="card border-0 shadow-sm rounded-4 p-3"
      style={{ background: "#f5f6fa" }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="fw-bold mb-0">{shift?.name}</h5>

        <div className="d-flex align-items-center gap-2">
          {shift?.status && (
            <span className={shift.status === "active" ? "badge-approved" : "badge-negotiation"}>
              {shift.status}
            </span>
          )}
          
          <Dropdown isOpen={dropdownOpen} toggle={toggle} className="setngs-dropdown">
            <DropdownToggle
              tag="span"
              data-toggle="dropdown"
              aria-expanded={dropdownOpen}
              style={{ cursor: 'pointer', padding: '4px' }}
            >
              <i className="fa fa-cog text-secondary" style={{ fontSize: '16px' }}></i>
            </DropdownToggle>
            <DropdownMenu end container="body" style={{ zIndex: 1050 }}>
              <DropdownItem onClick={handleStatusToggle}>
                Mark as {shift?.status === 'active' ? 'Inactive' : 'Active'}
              </DropdownItem>
              <DropdownItem onClick={handleEdit}>
                Edit Shift
              </DropdownItem>              <DropdownItem onClick={handleDelete} className="text-danger">
                Delete Shift
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>

      {/* Time */}
      <div className="d-flex gap-3 mb-3">
        <div className="bg-white rounded-4 text-center flex-fill py-3 border">
          <small className="text-secondary d-block">Start</small>
          <h4 className="fw-bold mb-0">{shift?.start_time}</h4>
        </div>

        <div className="bg-white rounded-4 text-center flex-fill py-3 border">
          <small className="text-secondary d-block">End</small>
          <h4 className="fw-bold mb-0">{shift?.end_time}</h4>
        </div>
      </div>

      {/* Tags */}
      <div className="d-flex flex-wrap gap-2 mb-2">
        {shift?.description?.split("\n").map((tag, index) => (
          <span
            key={index}
            className="badge bg-white text-secondary border rounded-pill px-3 py-2 fw-normal"
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
};


function SchedulesCard({ shifts, onRefresh }) {
  return (
    <div className="container mt-3">
      <div className="row g-4">
        {shifts && shifts.map((shift, index) => (
          <div className="col-lg-3 col-md-6" key={index}>
            <ShiftCard shift={shift} onRefresh={onRefresh} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default SchedulesCard;